import { PasswordInput, Group, Stack, Text } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useTranslation } from 'react-i18next';
import { PortalButton } from 'components/Button/PortalButton';
import { BsFloppy } from 'react-icons/bs';
import { useDrawerContext } from 'context/hooks';
import { useGetPasswordPolicy } from 'hooks/api/user/useGetPasswordPolicy';
import { useUpdatePassword } from 'hooks/api/user/useUpdatePassword';
import { PasswordField } from 'components/ControlledInputs/PasswordField';
import { validatePassword } from 'utils/validation';
import { useState } from 'react';
import { translateError } from 'utils/notifications';

export const PasswordForm = () => {
  const { t } = useTranslation();

  const form = useForm({
    initialValues: {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
    validate: {
      oldPassword: (value, values) => validatePassword('old', value, values),
      newPassword: (value, values) => validatePassword('new', value, values),
      confirmPassword: (value, values) => validatePassword('confirm', value, values),
    },
  });
  const { closeDrawer } = useDrawerContext();
  const { mutate: updatePassword, isPending, error } = useUpdatePassword({ callback: closeDrawer });
  const { policy } = useGetPasswordPolicy();
  const [newPasswordProgress, setNewPasswordProgress] = useState(0);
  const [confirmPasswordProgress, setConfirmPasswordProgress] = useState(0);

  return (
    <form onSubmit={form.onSubmit(() => updatePassword(form.values))}>
      <Stack gap={'md'}>
        <PasswordInput
          label={t('group_old_password_label')}
          withAsterisk
          {...form.getInputProps('oldPassword')}
          maxLength={policy?.maximumLength}
        />
        <PasswordField
          label={t('group_new_password_label')}
          {...form.getInputProps('newPassword')}
          onProgressChanged={(progress) => {
            setNewPasswordProgress(progress);
          }}
        />
        <PasswordField
          label={t('group_confirm_password_label')}
          {...form.getInputProps('confirmPassword')}
          onProgressChanged={(progress) => {
            setConfirmPasswordProgress(progress);
          }}
        />
        {error && (
          <Text size={'xs'} c={'red'}>
            {translateError(error)}
          </Text>
        )}
        <Group justify={'flex-start'}>
          <PortalButton
            type={'submit'}
            label={t('save_label')}
            loading={isPending}
            Icon={BsFloppy}
            disabled={form.values.oldPassword.length <= 0 || newPasswordProgress < 100 || confirmPasswordProgress < 100}
          />
          <PortalButton variant={'outline'} label={t('cancel_label')} onClick={closeDrawer} disabled={isPending} />
        </Group>
      </Stack>
    </form>
  );
};
